// src/modules/expert/custom-fields/routes.ts
import type { RouteRecordRaw } from 'vue-router'

export const customFieldsRoutes: RouteRecordRaw[] = [
  {
    path: ':id/custom-fields/select-type',
    name: 'select-custom-field-type',
    component: () => import('./views/SelectType.vue'),
  },
  {
    path: ':id/custom-fields/new',
    name: 'create-custom-field',
    component: () => import('./views/Create.vue'),
  },
  {
    path: ':id/custom-fields/:fieldId/edit',
    name: 'edit-custom-field',
    component: () => import('./views/Create.vue'),
    props: true,
  },
  // settings costuma viver fora do "custom-fields" direto, mantendo o nome usado nos links
  {
    path: ':id/settings/custom-fields',
    name: 'custom-fields-settings',
    component: () => import('./views/CustomFieldsSettings.vue'),
  },
]
